module.exports = __webpack_public_path__ + "static/media/rack-and-pinion.22de42ca.svg";